import React from 'react';
import { FAQPageJsonLd, NextSeo } from 'next-seo';
import { getSeoVisibility } from '../../appconfig';
import Head from 'next/head';
import { getJsonLdData } from '../../Utils/helper';

export default function BabyNamesHeadElements(props) {
  let {
    FAQPage = [],
    metaDescription,
    metaTitle,
    url,
    canonicalUrl,
    letter,
    hrefData = [],
    openGraphData = {},
  } = props;
  if (letter) FAQPage = getJsonLdData(letter);
  return (
    <>
      {getSeoVisibility() ? (
        // {true ? (
        <>
          <NextSeo
            title={metaTitle}
            description={metaDescription}
            languageAlternates={hrefData}
            openGraph={openGraphData}
          />
          {FAQPage?.length > 0 && <FAQPageJsonLd mainEntity={FAQPage} />}
        </>
      ) : null}
      <Head>
        {canonicalUrl && (
          <link key="canonical" rel="canonical" href={canonicalUrl} />
        )}
        <script
          async
          src="https://securepubads.g.doubleclick.net/tag/js/gpt.js"
        ></script>
      </Head>
    </>
  );
}
